import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "outer" }

import { ref, useTemplateRef, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import { showInfo } from '@services/utils/dialog';

import Modal from './Modal.vue';

import { useModal } from '@services/modal';
import { t, n } from '@services/l10n';
import { config } from '@services/user-config';
import * as dav from '@services/dav';
import * as utils from '@services/utils/common';

import type { IPhoto } from '@typings';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'MoveToFolderModal',
},
  __name: 'MoveToFolderModal',
  setup(__props) {

const NcProgressBar = defineAsyncComponent(() => import('@nextcloud/vue/components/NcProgressBar'));



const modal = useTemplateRef('modal');
const { show, close } = useModal(modal);
const route = useRoute();

const photos = ref<IPhoto[]>([]);
const photosDone = ref(0);

console.assert(!_m.modals.moveToFolder, 'MoveToFolderModal created twice');
_m.modals.moveToFolder = open;

function open(photosIn: IPhoto[]) {
  photosDone.value = 0;
  show.value = false;
  photos.value = photosIn;
  chooseFolderPath();
}

function cleanup() {
  show.value = false;
  photos.value = [];
}

async function chooseFolderPath() {
  enum Mode {
    Move = 1,
    Copy = 2,
    Organise = 3,
  }
  let mode: Mode = Mode.Move as Mode;
  let destination = await utils.chooseNcFolder(t('memories', 'Choose a folder'), config.folders_path, () => [
    {
      label: 'Move and organise',
      callback: () => void (mode = Mode.Organise),
    },
    {
      label: 'Copy',
      callback: () => void (mode = Mode.Copy),
    },
    {
      label: 'Move',
      type: 'primary',
      callback: () => void (mode = Mode.Move),
    },
  ]);

  // Fails if the target exists, same behavior with Nextcloud files implementation.
  let gen = (() => {
    switch (mode) {
      case Mode.Organise: {
        return dav.movePhotosByDate(photos.value, destination, false, { route });
      }
      case Mode.Copy: {
        return dav.copyPhotos(photos.value, destination, false, { route });
      }
      case Mode.Move: {
        return dav.movePhotos(photos.value, destination, false, { route });
      }
    }
  })();

  show.value = true;

  for await (const fids of gen) {
    photosDone.value += fids.filter(Boolean).length;
    utils.bus.emit('memories:timeline:soft-refresh', null);
  }

  const nPhotos = photosDone.value;
  if (mode === Mode.Copy) {
    showInfo(n('memories', '{n} item copied to folder', '{n} items copied to folder', nPhotos, { n: nPhotos }));
  } else {
    showInfo(n('memories', '{n} item moved to folder', '{n} items moved to folder', nPhotos, { n: nPhotos }));
  }
  close();
}

return (_ctx: any,_cache: any) => {
  return (_unref(show))
    ? (_openBlock(), _createBlock(Modal, {
        key: 0,
        ref_key: "modal",
        ref: modal,
        onClose: cleanup,
        size: "normal"
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('memories', 'Move to folder')), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(NcProgressBar), {
              value: Math.round((photosDone.value * 100) / Math.max(photos.value.length, 1)),
              error: true
            }, null, 8, ["value"])
          ])
        ]),
        _: 1
      }, 512))
    : _createCommentVNode("", true)
}
}

})